import React from 'react';
import { Popover } from 'antd';
import { FiInfo } from 'react-icons/fi';
import { BsStars } from 'react-icons/bs';
import { TbFrame } from 'react-icons/tb';

import styles from './InfoTooltip.module.scss';

export const InfoTooltipComponent = ({
  title,
  description,
  calculation = null,
  placement = 'top',
  icon: Icon = BsStars,
  showIcon = true,
  trigger = 'click',
}) => {
  const content = (
    <div className={styles.content}>
      <div className={styles.header}>
        {showIcon && (
          <span className={styles.iconBadge}>
            <Icon size={14} />
          </span>
        )}
        <span className={styles.title}>{title}</span>
      </div>

      {description && <p className={styles.description}>{description}</p>}

      {calculation?.formula && (
        <>
          <div className={styles.divider} />
          <div className={styles.calcRow}>
            <span className={styles.calcIcon}>
              <TbFrame size={16} />
            </span>
            <div className={styles.calcText}>
              <span className={styles.calcLabel}>
                {calculation.label || "How it's calculated"}
              </span>
              <span className={styles.calcFormula}>{calculation.formula}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger={trigger}
      placement={placement}
      arrow={{ pointAtCenter: true }}
      classNames={{ root: styles.popoverOverlay }}
    >
      <button
        type="button"
        className={styles.trigger}
        aria-label={`About ${title}`}
      >
        <FiInfo size={14} />
      </button>
    </Popover>
  );
};

InfoTooltipComponent.displayName = 'InfoTooltip';
